<template>
  <div class="container orders-wrap">
    <h1>{{$ml.with('VueJS').get('OrdersList')}}</h1>


      <div class="text-right pr-2 mb-2">
          <router-link to="/create-order">
              {{$ml.with('VueJS').get('CreateOrderLink')}}
          </router-link>
      </div>

      <div class="list-wrap border rounded pb-2">
          <div class="table-head px-2 pt-2 border-bottom">
              <div class="filter-wrap border rounded d-flex flex-wrap mb-2">
                  <div class="col-1 px-0 align-self-center">
                        <font-awesome-icon icon="search"></font-awesome-icon>
                  </div>
                  <div class="col-10 px-0">
                      <vue-tags-input
                              :placeholder="$ml.with('VueJS').get('SearchParams')"
                              class="w-100"
                              v-model="tag"
                              :tags="tags"
                              @tags-changed="newTags => tags = newTags"
                      />
                  </div>
                  <div class="col-1 px-0 align-self-center">
                        <font-awesome-icon v-if="tags.length > 0" icon="times" @click="tags = []"></font-awesome-icon>
                  </div>
              </div>
              <div class="column-labels-wrap d-flex flex-wrap">
                  <div class="col-md-3 text-left overflow-hidden">
                      {{$ml.with('VueJS').get('OrderNumber')}}
                  </div>
                  <div class="col-4 col-md-2 overflow-hidden">
                      {{$ml.with('VueJS').get('Sum')}}
                  </div>
                  <div class="col-4 col-md-2 overflow-hidden">
                      {{$ml.with('VueJS').get('OrderDate')}}
                  </div>
                  <div class="col-4 col-md-2 text-center overflow-hidden">
                      {{$ml.with('VueJS').get('OrderStatus')}}
                  </div>
                  <div class="col-md-3">
                      {{$ml.with('VueJS').get('OrderDocuments')}}
                  </div>
              </div>
          </div>

          <div class="rows-wrap ">
              <div :class="rowIndex === ordersList.length-1 ? 'd-flex flex-wrap row-wrap py-2 px-2' : 'd-flex flex-wrap row-wrap py-2 px-2 border-bottom'" v-for="(row, rowIndex) in ordersList" v-bind:key="row.id">
                  <div class="col-6 col-md-3 text-left align-self-center">
                      <div class="title d-inline-block">
                          <b-button
                                  @click="showOrderDetails(row)"
                                  size="sm"
                                  variant="none"
                                  tabindex="0"
                                  v-b-tooltip.hover
                                  :title="$ml.with('VueJS').get('OrderDetails')"
                          >
                              № {{row.id}} <font-awesome-icon icon="question-circle"></font-awesome-icon>
                          </b-button>
                          <router-link
                                  :to="'/update-order/' + row.id"
                                  class="btn btn-sm"
                          >
                              <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
                          </router-link>
                      </div>
                      <div class="options-wrap">
                          {{row.pharm.name}}
                      </div>
                  </div>
                  <div class="col-4 col-md-2 align-self-center">
                      {{row.sum / 100}}
                  </div>
                  <div class="col-4 col-md-2 align-self-center">
                    {{row.created_at}}
                  </div>
                  <div class="col-4 col-md-2 align-self-center">
                      <div class="status-wrap">
                          <!--{{$ml.with('VueJS').get('OrderStatus' + row.status)}}-->
                          <b-form-select
                                  class="mb-2"
                                  value-field="id"
                                  :text-field="$ml.current === nationalLanguage ? 'ru_title' : 'en_title'"
                                  v-model="ordersList[rowIndex].status"
                                  :options="orderStatuses">
                          </b-form-select>
                          <a class="btn btn-warning btn-sm" @click="updateOrderStatus(row)">
                              <span>{{$ml.with('VueJS').get('UpdateOrderStatus')}}</span>
                          </a>
                      </div>
                      <div class="ship-order-wrap mt-2" v-if="Number(row.status) === 4">
                          <b-button @click="showShippingParamsModal(row)" size="sm" variant="info" tabindex="0">
                              {{$ml.with('VueJS').get('EnterTrackingNumber')}}
                          </b-button>
                      </div>
                  </div>
                  <div class="col-md-3 align-self-center">
                      <div v-if="row.documents.length" class="text-left">
                          <div class="document-wrap"
                               v-for="(document, docIndex) in row.documents"
                               v-bind:key="row.id + ':' + document.id"
                          >
                              <b-form-checkbox
                                      :id="'checkbox-' + row.id + '-' + document.type"
                                      v-model="ordersList[rowIndex].documents[docIndex].selected"
                                      :name="'checkbox-' + row.id + '-' + document.type"
                                      :value="true"
                                      :unchecked-value="false"
                                      inline
                              >
                              </b-form-checkbox>
                              <a :href="document.url" :class="[`doc-${docIndex}`, 'document__link']" target="_blank">
                                  {{$ml.with('VueJS').get('DocumentType_' + document.type)}}
                              </a>
                          </div>
                          <div  >
                              <b-form-select
                                      v-model="row.eds_type"
                                      :options="edsTypes"
                                      value-field="id"
                                      :text-field="$ml.current === nationalLanguage ? 'ru_title' : 'en_title'"
                                      class="mb-2"
                              ></b-form-select>
                              <a class="btn btn-info btn-sm" @click="sendEDS(row)">
                                  <span>{{$ml.with('VueJS').get('SendEDS')}}</span>
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="d-flex flex-wrap">
              <div class="col-md-8">
                  <div class="pagination-wrap" v-if="pageCount > 1">
                      <b-pagination
                              v-model="currentPage"
                              :total-rows="totalCount"
                              :per-page="perPage"
                              :disabled="isLoading"
                              size="sm"
                      ></b-pagination>
                  </div>
              </div>
              <div class="col-md-4">
                  {{$ml.get('paginationPageOfMessage')}}
              </div>
          </div>
      </div>


      <b-modal id="orderDetails" size="lg" hide-footer :title="$ml.with('VueJS').get('OrderDetails')" v-model="showOrderDetailsModal">
          <div class="modal-body-wrap">
                <div class="billing-wrap" v-for="pharmCompany in statusFilteredCurrentOrderItems" v-bind:key="pharmCompany.id">
                    <div class="pharmcompany-title">
                        <strong class="mr-2">{{pharmCompany.name}}</strong>
                        <b-button @click="approve(pharmCompany)" size="sm" class="mr-1" variant="success">
                            <font-awesome-icon icon="thumbs-up"></font-awesome-icon>
                        </b-button>
                        <b-button @click="decline(pharmCompany)" size="sm" variant="danger">
                            <font-awesome-icon icon="ban"></font-awesome-icon>
                        </b-button>
                    </div>
                    <div class="items-wrap pl-2">
                        <div class="item-wrap" v-for="item in pharmCompany.items" v-bind:key="item.id">
                            {{$ml.current === nationalLanguage || !item.good.en_name ? item.good.ru_name : item.good.en_name}}
                            {{item.cost}} x {{item.quantity}}
                        </div>
                    </div>
                </div>
                <div v-if="statusFilteredCurrentOrderItems.length === 0">
                    {{$ml.with('VueJS').get('NoUnmoderatedItemsLeft')}}
                </div>
          </div>
      </b-modal>

      <b-modal id="shipOrder" size="lg" hide-footer :title="$ml.with('VueJS').get('ShipOrderModalTitle')" v-model="showShipOrderModal">
          <div class="modal-body-wrap">
              <!--<FormulateForm
                      class="login-form"
                      v-model="shippingParams"
                      @submit="setOrderShippingParams()"
              >
                  <FormulateInput
                          type="text"
                          :label="$ml.with('VueJS').get('TrackingNumber')"
                          name="trackingNumber"
                          :validation="[
                            ['required'],
                            ['min', 3]
                          ]"
                          :validation-messages="{
                            required: $ml.with('VueJS').get('RequiredField'),
                            min: ({ args }) => `${$ml.with('VueJS').get('FieldMinLengthRule')} ${args[0]}`,
                          }"
                  />


                      <FormulateInput
                              type="submit"
                              :label="$ml.with('VueJS').get('Save')"
                      />

              </FormulateForm>-->

              <b-form-group
                      id="input-group-track-number"
                      label=""
                      label-for="input-track-number"
                      description=""
              >
                  <b-form-input
                          id="input-track-number"
                          v-model="shippingParams.trackingNumber"
                          :placeholder="$ml.with('VueJS').get('TrackingNumber')"
                  ></b-form-input>
              </b-form-group>

              <b-button @click="submitTrackNumber()" variant="success">
                  Сохранить
              </b-button>
          </div>
      </b-modal>

  </div>
</template>

<style>
    .custom-control-inline {
        margin-right: 0px;
        padding-top: 8px;
        /*padding-left: 0px;*/
    }
    .green {
        color: green;
    }
    .red {
        color: red;
    }
    .filter-wrap {
        background-color: #fff;
    }
    .vue-tags-input {
        max-width: 100%!important;
    }
    .vue-tags-input .ti-input {
        border: none!important;
    }
    .table-head {
        background-color: #F6F7FB;
    }
    .column-labels-wrap {
        font-weight: bold;
    }
    .filter-wrap .input-group-prepend .input-group-text, .filter-wrap .input-group-append .input-group-text {
        background-color: #fff;
    }
    .rows-wrap {
        font-size: 14px;
    }
    .rows-wrap .title {
        font-weight: bold;
    }
    .rows-wrap .options-wrap {
        color: #647C9F;
    }
    #input-group-quantity label {
        font-weight: bold;
    }
    .modal-body .input-group-prepend .input-group-text {
        min-width: 150px;
    }
    .document__link {
      word-break: break-all;
    }
</style>
<script>
  import mixinUtils from "@/components/mixinUtils"
  import {MLBuilder} from 'vue-multilanguage'
  import VueTagsInput from '@johmun/vue-tags-input'
  import {dataFlowControlRoot, edsTypes, nationalLanguage, orderStatuses} from "@/helpers/variables";

  export default {
    name: 'orders-list',
    mixins: [mixinUtils],
    components: {
      VueTagsInput,
    },
    data: () => ({
      nationalLanguage: nationalLanguage,
      orderStatuses: orderStatuses,
      dataFlowControlRoot: dataFlowControlRoot,
        edsTypes: edsTypes,
      filter: null,
      tag: '',
      tags: [],
      showOrderDetailsModal: false,
      showShipOrderModal: false,
      shippingParams: {
        orderId: null,
        trackingNumber: null,
      },
      currentOrder: {
        id: null,
        created_at: null,
        status: null,
        sum: null,
      },
      currentOrderFilters: {
        filterOrderItemsByMaker: null,
      },
      currentOrderItems: {},
      ordersList: [],
      storagesList: [],
      isLoading: false,
      currentPage: 1,
      pageCount: 1,
      totalCount: null,
      perPage: 20,
      interval: null,
    }),
    methods: {
      submitTrackNumber() {
        const contex = this
        const order = contex.ordersList.find(obj => {
          return obj.id === contex.shippingParams.orderId
        })
        if (order !== undefined) {
          order.trackNumber = contex.shippingParams.trackingNumber
        }
        contex.showShipOrderModal = false
      },
      updateOrderStatus (row) {
        const contex = this

        if (row.status == 4 && !row.trackNumber) {
          contex.showShipOrderModal = true
          return
        }

        contex.apiCall(`orders/update-status`, 'post', {
          order_id: row.id,
          status: row.status,
          track_number: row.trackNumber,
        })
          .then(function (response) {
            if (response.status === 200) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('OrderStatusSuccessfullyChanged'), {
                title: contex.$ml.with('VueJS').get('OrdersList'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            } else {
              contex.$bvToast.toast(`${response.name}: ${response.message}`, {
                title: contex.$ml.with('VueJS').get('OrdersList'),
                autoHideDelay: 5000,
                variant: 'danger',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
        })
      },
      sendEDS (row) {
        const contex = this
        const items = []
        for (let i = 0; i < row.documents.length; i++) {
          const document = row.documents[i]
          items.push(document.id)
        }

        contex.apiCall(`data-flow/send-to-eds`, 'post', {
          items: items,
          processId: row.process_id,
          edsType: row.eds_type,
        })
          .then(function (response) {
            if (response.status === 200) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('DocumentsSuccessfullySent'), {
                title: contex.$ml.with('VueJS').get('OrdersList'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            } else {
              contex.$bvToast.toast(`${response.name}: ${response.message}`, {
                title: contex.$ml.with('VueJS').get('OrdersList'),
                autoHideDelay: 5000,
                variant: 'danger',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
        })
      },
      cleanUpShippingParams () {
        this.shippingParams = {
          orderId: null,
          trackingNumber: null,
        }
      },
      showShippingParamsModal (row) {
        const contex = this
        contex.showShipOrderModal = true
        contex.shippingParams.orderId = row.id
        contex.shippingParams.trackingNumber = row.trackNumber
      },
      setOrderShippingParams () {
        const contex = this
        contex.apiCall(`orders/set-shipping-params`, 'post', contex.shippingParams)
          .then(function (response) {
            if (Number(response.data.status) === 200) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('OrderShippedOut'), {
                title: contex.$ml.with('VueJS').get('OrdersList'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })

              contex.cleanUpShippingParams()
              contex.getOrders()
              contex.showShipOrderModal = false
            }
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
        })
      },
      closeModalIfEmpty() {
        if (this.statusFilteredCurrentOrderItems.length === 0) {
          this.showOrderDetailsModal = false
        }
      },
      approve(pharmCompany) {
        const contex = this

        contex.apiCall(`orders/approve`, 'post', {pcId: pharmCompany.id, items: [pharmCompany.billingId]})
          .then(function (response) {
            if (Number(response.data.status) === 200 && response.data.errors.length === 0) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('OrderApproved'), {
                title: contex.$ml.with('VueJS').get('OrdersList'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
              console.log('approved')

              contex.getOrders()
              contex.getOrderItems(contex.currentOrder.id)
              contex.closeModalIfEmpty()
            } else {
              let message = ''
              if (Array.isArray(response.data.errors)) {
                message = response.data.errors[0]
              } else {
                message = response.data.errors[Object.keys(response.data.errors)[0]]
              }
              contex.$bvToast.toast(`Ошибка: ${message}`, {
                title: contex.$ml.with('VueJS').get('OrdersList'),
                autoHideDelay: 5000,
                variant: 'danger',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
        })
      },
      decline(pharmCompany) {
        const contex = this

        contex.apiCall(`orders/reject`, 'post', {pcId: pharmCompany.id, items: [pharmCompany.billingId]})
          .then(function (response) {
            if (Number(response.data.status) === 200) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('OrderApproved'), {
                title: contex.$ml.with('VueJS').get('OrdersList'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })

              contex.getOrders()
              contex.getOrderItems(contex.currentOrder.id)
              contex.closeModalIfEmpty()
            } else {
              contex.$bvToast.toast(`Ошибка: ${response.data.errors[0]}`, {
                title: contex.$ml.with('VueJS').get('OrdersList'),
                autoHideDelay: 5000,
                variant: 'danger',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
        })
      },
      clearCurrentOrder () {
        this.currentOrderItems = []
      },
      updateOrderItems () {
        const contex = this
        contex.showOrderDetailsModal = false
        if (contex.isLoading) return;

        contex.isLoading = true
        const form = {
          orderId: contex.currentOrder.id,
          items: [],
        }
        for (let i = 0; i < contex.currentOrderItems.length; i++) {
          form.items.push({
            id: contex.currentOrderItems[i].id,
            quantity: contex.currentOrderItems[i].quantity,
            status: contex.currentOrderItems[i].status,
          })
        }
        contex.apiCall(`orders/update-order`, 'post', form)
          .then(function (response) {
            /*if (response.data.id !== undefined) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('OrderUpdated'), {
                title: contex.$ml.with('VueJS').get('OrdersList'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })

            }*/
            console.log(response)
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
            contex.isLoading = false
        })
        contex.clearCurrentOrder()
      },
      showOrderDetails (row) {
        this.currentOrder = row
        this.showOrderDetailsModal = true
        this.getOrderItems(row.id)
      },
      getOrderItems (orderId) {
        const contex = this
        //if (contex.isLoading) return;

        //contex.isLoading = true
        contex.currentOrderItems = []
        contex.apiCall(`orders/order-billings?orderId=${orderId}`, 'post', {})
          .then(function (response) {
            /*if (Number(response.status) === 200) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('DataSuccessfullyReceived'), {
                title: contex.$ml.with('VueJS').get('OrderItemsList'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }*/

            const result = {}
            for(let i = 0; i < response.data.length; i++) {
              const billingItem = response.data[i]

              if (result[billingItem.pharmcompany.id] === undefined) {
                result[billingItem.pharmcompany.id] = {
                  id: billingItem.pharmcompany.id,
                  uin: billingItem.pharmcompany.uin,
                  name: billingItem.pharmcompany.name,
                  inn: billingItem.pharmcompany.inn,
                  items: [],
                  billingId: billingItem.billing_id,
                  billingItems: [],
                  status: billingItem.billing.status,
                }
              }

              result[billingItem.pharmcompany.id].billingItems.push(billingItem.id)
              result[billingItem.pharmcompany.id].items.push({
                id: billingItem.orderItem.id,
                orderQuantity: billingItem.orderItem.quantity,
                orderCost: billingItem.orderItem.cost / 100,
                good: billingItem.goodViaGoodPartition,
              })
            }

            contex.currentOrderItems = result
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
          contex.isLoading = false
        })
      },
      getOrders () {
        const contex = this
        if (contex.isLoading) return;

        contex.isLoading = true
        contex.apiCall(`orders/index?expand=pharm&page=${contex.currentPage}&per-page=${contex.perPage}`, 'post', {})
          .then(function (response) {
            /*if (response.status === 200) {
              contex.$bvToast.toast(contex.$ml.with('VueJS').get('DataSuccessfullyReceived'), {
                title: contex.$ml.with('VueJS').get('OrdersList'),
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }*/

            contex.ordersList = []
            for (let i = 0; i < response.data.items.length; i++) {
              const data = response.data.items[i]

              if (data.documents !== null) {
                const tmp = data.documents
                data.documents = []
                for (let key in tmp) {
                  if (tmp[key].id === undefined) {
                    continue
                  }
                  const document = {
                    type: tmp[key].type,
                    url: tmp[key].url,
                    id: tmp[key].id,
                    selected: ['universal_transfer_document', 'order', 'bill-contract'].includes(tmp[key].type),
                  }

                  data.documents.push(document)
                }
              } else {
                data.documents = []
              }
              data.eds_type = null
              data.trackNumber = null

              contex.ordersList.push(data)
            }

            contex.currentPage = response.data._meta.currentPage
            contex.pageCount = response.data._meta.pageCount
            contex.totalCount = response.data._meta.totalCount
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
          contex.isLoading = false
        })
      }
    },
    mounted() {
      const context = this
      context.getOrders()

      context.interval = setInterval(() => context.getOrders(), 15000);
    },
    watch: {
      currentPage: {
        // eslint-disable-next-line no-unused-vars
        handler: function(newVal, oldVal) {
          this.getOrders()
        }
      }
    },
    computed: {
      statusFilteredCurrentOrderItems () {
        const contex = this
        const result = []
        Object.keys(this.currentOrderItems).forEach(function(key) {
          const currentItem = contex.currentOrderItems[key]
          if (Number(currentItem.status) === 2) {
            result.push(currentItem)
          }
        })

        return result
      },
      filteredItems () {
        const contex = this
        if (!contex.currentOrderFilters.filterOrderItemsByMaker) {
          return contex.currentOrderItems
        }

        return contex.currentOrderItems.filter(obj => {
          return Number(obj.maker_id) === Number(contex.currentOrderFilters.filterOrderItemsByMaker)
        })
      },
      orderProducers () {
        const contex = this
        const result = [
          {
            id: null,
            ru_name: 'Отфильтровать по производителю',
            en_name: 'Filter items by producer',
          }
        ]
        for (let i = 0; i < contex.currentOrderItems.length; i++) {
          const currentItem = {
            id: contex.currentOrderItems[i].maker_id,
            ru_name: contex.currentOrderItems[i].maker_ru_name,
            en_name: contex.currentOrderItems[i].maker_en_name,
          }
          const resultItem = result.find(obj => {
            return Number(obj.id) === Number(currentItem.id)
          })

          if (resultItem === undefined) {
            result.push(currentItem)
          }
        }

        return result
      },
      mlpaginationPageOfMessage () {
        return new MLBuilder('PaginationPageOf').with('pageNum', this.currentPage).with('totalPages', this.pageCount)
      },
      computedProductsList () {
        return this.ordersList
      }
    }
  }
</script>
